import React from 'react'
import PropTypes from 'prop-types'
import { currencyFormat } from 'utils/format'
import { DescItemInfo } from 'ui-components/DescItemInfo'
import { Card } from 'ui-components/Card'
import { CardTitle } from 'ui-components/CardTitle'

export default function BasicInfo({ product }) {
  return (
    <Card>
      <CardTitle title="DADOS BÁSICOS" noMargin />
      <DescItemInfo label="Descrição">
        {product.attributes.description}
      </DescItemInfo>

      <DescItemInfo label="Preço total de venda">
        {currencyFormat(product.attributes.selling_price)}
      </DescItemInfo>

      <DescItemInfo label="Margem de lucro %">
        {product.attributes.net_profit}
      </DescItemInfo>

      <DescItemInfo label="Garantia">
        {product.attributes.warranty}
      </DescItemInfo>

      <DescItemInfo label="Fabricante">
        {product.attributes.manufacturer?.name}
      </DescItemInfo>

      <DescItemInfo label="Grupo">
        {product.attributes.group?.name}
      </DescItemInfo>

      <DescItemInfo label="Categoria">
        {product.attributes.category?.name}
      </DescItemInfo>

      <CardTitle title="CÓDIGOS" />
      <DescItemInfo label="Código interno">
        {product.attributes.bar_code}
      </DescItemInfo>

      <DescItemInfo label="Código do fornecedor">
        {product.attributes.original_code}
      </DescItemInfo>

      <DescItemInfo label="Código de busca">
        {product.attributes.custom_search_parameters}
      </DescItemInfo>
    </Card>
  )
}

BasicInfo.propTypes = {
  product: PropTypes.objectOf(PropTypes.any).isRequired,
}
